export default __webpack_public_path__ + "static/media/coinca l plano1.5ad3bb68.jpg";